'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialVimeoCircular = function TiSocialVimeoCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.1 15.2c-0.8 0-1.6 0.4-2.4 1.2-0.5 0.5-0.8 1.2-0.9 1.9 0.3-0.3 0.6-0.4 0.9-0.4 0.2 0 0.5 0.2 0.6 0.4 0.4 0.5 0.3 1 0 1.7-0.8 1.6-1.4 2.4-1.8 2.4-0.3 0-0.6-0.9-1-2.6-0.1-0.3-0.1-0.7-0.2-1.1-0.1-0.5-0.2-0.9-0.2-1.3-0.1-0.4-0.2-0.7-0.4-1.1s-0.3-0.6-0.5-0.8c-0.2-0.1-0.4-0.2-0.6-0.2-0.1 0-0.2 0-0.3 0.1-0.4 0.1-1 0.4-1.6 0.9-0.7 0.4-1.2 0.9-1.6 1.4l-0.5 0.6 0.5 0.7c0-0.1 0.1-0.2 0.2-0.2 0.1-0.1 0.3-0.2 0.6-0.3 0.2-0.1 0.3-0.1 0.4-0.1 0.1 0 0.2 0.1 0.2 0.1 0.1 0.2 0.5 1.2 1 3.2 0.6 1.9 1 3 1.1 3.3 0.3 0.6 0.6 1 1.1 1.2 0.2 0.2 0.4 0.2 0.7 0.2 0.3 0 0.6 0 0.9-0.2 1-0.7 2.1-1.8 3.4-3.3 1.3-1.6 2.1-3.2 2.4-5 0.3-1.5-0.2-2.4-1.3-2.6-0.3 0-0.5-0.1-0.7-0.1z m-4.1 19.8c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z' })
        )
    );
};

exports.default = TiSocialVimeoCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-vimeo-circular.js
// module id = 2193
// module chunks = 0